import React from "react";
import { imgUrl } from "./../lib/format.js";

// Official SVG paths and brand colors for major social platforms
export const PLATFORMS = [
  {
    id: "facebook",
    name: "Facebook",
    defaultUrl: "https://www.facebook.com/",
    color: "#1877F2",
    badgeBg: "#EBF5FF",
    border: "#C3DDFD",
    renderIcon: (props) => (
      <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
  },
  {
    id: "instagram",
    name: "Instagram",
    defaultUrl: "https://www.instagram.com/",
    color: "#E4405F",
    badgeBg: "#FDF2F4",
    border: "#FBCFE8",
    renderIcon: (props) => (
      <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
      </svg>
    ),
  },
  {
    id: "whatsapp",
    name: "WhatsApp",
    defaultUrl: "https://wa.me/91",
    color: "#25D366",
    badgeBg: "#F0FDF4",
    border: "#BBF7D0",
    renderIcon: (props) => (
      <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
      </svg>
    ),
  },
  {
    id: "youtube",
    name: "YouTube",
    defaultUrl: "https://www.youtube.com/@",
    color: "#FF0000",
    badgeBg: "#FEF2F2",
    border: "#FECACA",
    renderIcon: (props) => (
      <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
      </svg>
    ),
  },
  {
    id: "twitter",
    name: "X (Twitter)",
    defaultUrl: "https://x.com/",
    color: "#000000",
    badgeBg: "#F3F4F6",
    border: "#E5E7EB",
    renderIcon: (props) => (
      <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
  },
  {
    id: "linkedin",
    name: "LinkedIn",
    defaultUrl: "https://www.linkedin.com/company/",
    color: "#0A66C2",
    badgeBg: "#F0F9FF",
    border: "#BAE6FD",
    renderIcon: (props) => (
      <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
      </svg>
    ),
  },
  {
    id: "pinterest",
    name: "Pinterest",
    defaultUrl: "https://www.pinterest.com/",
    color: "#E60023",
    badgeBg: "#FEF2F2",
    border: "#FECACA",
    renderIcon: (props) => (
      <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M12 0a12 12 0 0 0-4.37 23.18c-.07-.98-.13-2.49.03-3.56.14-.97 1.05-4.47 1.05-4.47s-.27-.54-.27-1.34c0-1.25.73-2.19 1.63-2.19.77 0 1.14.58 1.14 1.27 0 .78-.49 1.94-.75 3.01-.21.9.45 1.63 1.34 1.63 1.61 0 2.85-1.7 2.85-4.15 0-2.17-1.56-3.69-3.79-3.69-2.58 0-4.09 1.94-4.09 3.93 0 .78.3 1.62.68 2.07.07.09.08.17.06.26-.07.29-.23.95-.26 1.08-.04.18-.14.22-.32.13-1.2-.56-1.95-2.31-1.95-3.72 0-3.03 2.2-5.81 6.35-5.81 3.33 0 5.92 2.37 5.92 5.55 0 3.31-2.09 5.98-4.99 5.98-.97 0-1.89-.51-2.2-.11l-.6 2.28c-.22.84-.81 1.89-1.21 2.53A11.98 11.98 0 0 0 12 24c6.63 0 12-5.37 12-12S18.63 0 12 0z" />
      </svg>
    ),
  },
  {
    id: "telegram",
    name: "Telegram",
    defaultUrl: "https://t.me/",
    color: "#229ED9",
    badgeBg: "#F0F9FF",
    border: "#BAE6FD",
    renderIcon: (props) => (
      <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0zm5.56 8.16l-1.98 9.35c-.15.66-.54.82-1.09.51l-3.04-2.24-1.47 1.41c-.16.16-.3.3-.61.3l.22-3.11 5.66-5.11c.25-.22-.05-.34-.38-.12L8.89 13.43l-3.02-.94c-.66-.21-.67-.66.14-.98l11.8-4.55c.55-.2 1.02.13.75 1.2z" />
      </svg>
    ),
  },
  {
    id: "threads",
    name: "Threads",
    defaultUrl: "https://www.threads.net/@",
    color: "#000000",
    badgeBg: "#F3F4F6",
    border: "#E5E7EB",
    renderIcon: (props) => (
      <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M12.001 0C5.373 0 0 5.373 0 12c0 6.626 5.373 12 12.001 12 6.627 0 11.999-5.374 11.999-12 0-6.627-5.372-12-11.999-12zm4.773 13.84c-.216 1.777-1.393 3.033-3.235 3.447-1.892.425-3.876-.231-4.832-1.602-.453-.65-.688-1.464-.688-2.378 0-2.421 1.637-4.14 4.093-4.305.857-.058 1.7.07 2.475.376.126-.81-.122-1.528-.718-1.992-.563-.437-1.353-.559-2.164-.333-.787.22-1.42.748-1.748 1.458l-1.815-.99c.563-1.22 1.66-2.128 3.022-2.5 1.466-.4 2.929-.19 4.015.6 1.135.824 1.688 2.148 1.516 3.633l-.533 4.316c-.058.468.106.848.42 1.025.328.185.739.117 1.05-.18.236-.226.4-.537.49-.933l1.83.62c-.18.804-.577 1.492-1.157 1.992-1.07.922-2.527 1.01-3.667.35-.615-.357-.96-.93-1.04-1.614zm-4.72-.05c.813 0 1.545-.333 1.986-.89.378-.476.55-1.127.483-1.832-.572-.25-1.19-.364-1.8-.323-1.34.09-2.227.973-2.227 2.217 0 .47.118.895.348 1.23.284.414.71.598 1.21.598z" />
      </svg>
    ),
  },
  {
    id: "snapchat",
    name: "Snapchat",
    defaultUrl: "https://www.snapchat.com/add/",
    color: "#EAB308",
    badgeBg: "#FEFCE8",
    border: "#FEF08A",
    renderIcon: (props) => (
      <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M12.036 0C6.012 0 4.19 3.652 4.19 5.86c0 1.258.444 3.42 1.168 4.708.204.364.12.632-.178.854-.51.382-1.317.848-2.072 1.096-.445.146-.62.383-.62.623 0 .408.47.747 1.295.945.31.074.453.25.438.532-.06.944-.306 1.83-.919 2.508-.344.38-.415.698-.21.992.235.337.74.444 1.487.32.483-.08.97-.247 1.455-.457.34-.147.59-.06.74.246.33.673.864 1.206 1.548 1.554.498.254.792.656.772 1.18-.035.918-.733 1.527-1.884 1.637-.417.04-.635.244-.635.534 0 .47.534.82 1.46.953.94.135 2.05-.03 3.39-.49.497-.17 1.018-.17 1.516 0 1.34.46 2.45.625 3.39.49.926-.133 1.46-.483 1.46-.953 0-.29-.218-.494-.635-.534-1.15-.11-1.85-.72-1.884-1.637-.02-.524.274-.926.772-1.18.684-.348 1.218-.88 1.548-1.554.15-.306.4-.393.74-.246.485.21.972.377 1.455.457.747.124 1.252.017 1.487-.32.205-.294.134-.612-.21-.992-.613-.678-.859-1.564-.919-2.508-.015-.282.128-.458.438-.532.825-.198 1.295-.537 1.295-.945 0-.24-.175-.477-.62-.623-.755-.248-1.562-.714-2.072-1.096-.298-.222-.382-.49-.178-.854.724-1.288 1.168-3.45 1.168-4.708C19.882 3.652 18.06 0 12.036 0z" />
      </svg>
    ),
  },
  {
    id: "website",
    name: "Website / Store",
    defaultUrl: "https://",
    color: "#059669",
    badgeBg: "#ECFDF5",
    border: "#A7F3D0",
    renderIcon: (props) => (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
    ),
  },
  {
    id: "email",
    name: "Email Address",
    defaultUrl: "mailto:support@sanjeevika.com",
    color: "#D97706",
    badgeBg: "#FFFBEB",
    border: "#FDE68A",
    renderIcon: (props) => (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        <polyline points="22,6 12,13 2,6" />
      </svg>
    ),
  },
  {
    id: "phone",
    name: "Phone Number",
    defaultUrl: "tel:+91",
    color: "#2563EB",
    badgeBg: "#EFF6FF",
    border: "#BFDBFE",
    renderIcon: (props) => (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
      </svg>
    ),
  },
  {
    id: "custom",
    name: "Custom Link",
    defaultUrl: "https://",
    color: "#6B7280",
    badgeBg: "#F9FAFB",
    border: "#E5E7EB",
    renderIcon: (props) => (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
      </svg>
    ),
  },
];

// Helper to look up a platform definition by ID (case-insensitive)
export function getPlatform(id) {
  if (!id) return PLATFORMS[PLATFORMS.length - 1]; // fallback to custom
  const clean = String(id).toLowerCase().trim();
  const match = PLATFORMS.find((p) => p.id === clean);
  return match || PLATFORMS[PLATFORMS.length - 1];
}

/**
 * SocialIconBadge Component
 * Renders either:
 * 1) A custom uploaded icon image (via file preview or stored path)
 * 2) Or the official SVG platform icon with brand color styling
 */
export default function SocialIconBadge({
  platform,
  iconImage,
  size = "md",
  className = "",
  showBorder = true,
}) {
  const p = getPlatform(platform);

  // Size dimensions
  const sizeMap = {
    sm: { box: "h-7 w-7 rounded-md", icon: "h-3.5 w-3.5" },
    md: { box: "h-10 w-10 rounded-lg", icon: "h-5 w-5" },
    lg: { box: "h-12 w-12 rounded-xl", icon: "h-6 w-6" },
  };
  const s = sizeMap[size] || sizeMap.md;

  // If a custom image exists (either File object or string URL/path)
  if (iconImage) {
    const src =
      typeof iconImage === "string"
        ? imgUrl(iconImage)
        : URL.createObjectURL(iconImage);

    return (
      <div
        className={`flex items-center justify-center overflow-hidden bg-white ${s.box} ${
          showBorder ? "border border-gray-200 shadow-xs" : ""
        } ${className}`}
      >
        <img
          src={src}
          alt={p.name}
          className="h-full w-full object-contain p-1"
          onError={(e) => {
            e.target.style.display = "none";
          }}
        />
      </div>
    );
  }

  // Preset SVG icon with brand color
  return (
    <div
      className={`flex items-center justify-center transition-transform ${s.box} ${className}`}
      style={{
        backgroundColor: p.badgeBg,
        borderColor: showBorder ? p.border : "transparent",
        borderWidth: showBorder ? "1px" : "0px",
        color: p.color,
      }}
      title={p.name}
    >
      {p.renderIcon({ className: s.icon })}
    </div>
  );
}
